export function eventTracking() {
  function init() {
    const elements = document.querySelectorAll(".js-track-event");

    elements.forEach(function (element, elementIndex) {
      element.addEventListener("click", function () {
        const eventName = element.getAttribute("data-event-name");

        const affiliateEvents = [
          "affiliate_button_click",
          "affiliate_logo_click",
          "affiliate_title_click",
          "affiliate_terms_click",
          "affiliate_phone_click",
        ];

        if (affiliateEvents.includes(eventName)) {
          const affiliateName = element.getAttribute("data-affiliate-name");
          const affiliateRank = element.getAttribute("data-affiliate-rank");
          const elementPlacement = element.getAttribute(
            "data-element-placement"
          );

          dataLayer.push({
            event: eventName,
            affiliate_name: affiliateName,
            affiliate_rank: affiliateRank,
            element_placement: elementPlacement,
            ...(eventName === "affiliate_phone_click" && {
              phone_number: element.getAttribute("href").replace("tel:", ""),
            }),
          });
        } else {
          dataLayer.push({ event: eventName });
        }
      });
    });
  }

  return {
    init: init,
  };
}
